/* eslint-disable */
import React, { useState } from "react";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import usePagination from "../../../helper/paginate/Pagination";
import Swal from "sweetalert2";
import "../../../../pages/dashboard/yoda.css";
import "./DataTableDemo.css";
import { useSelector } from "react-redux";
import apicache from "../../../../components/clearCach/clear";
import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronUp, Edit, Plus, X, Settings } from "lucide-react";
import {
  Pagination,
  Stack,
  Modal,
  Box,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import useIsDark from "../../../../utils/isDark";
import workerAPI from "../../../../api/worker/worker_service";
import { useDispatch } from "react-redux";
import { updateProduct } from "../../../../redux/products/products";

const DataTableTemplatingDemoSettings = ({
  filter,
  products,
  displayColumns = null,
}) => {
  // If direct products array is provided, use it, otherwise use Redux data
  const dispatch = useDispatch();
  const reduxProducts = useSelector((state) => state.ProductsReducer);
  const productsToDisplay = products || reduxProducts;
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  let [page, setPage] = useState(1);
  const PER_PAGE = 6;
  const { t, i18n } = useTranslation();
  const [expandedRows, setExpandedRows] = useState({});
  const count = Math.ceil(productsToDisplay.length / PER_PAGE);
  const _DATA = usePagination(productsToDisplay, PER_PAGE);
  const isDark = useIsDark();
  const currencyMap = {
    دج: {
      ar: "دج",
      fr: "DA",
      en: "DZD",
    },
  };
  const localizedCurrency =
    currencyMap[store.currencySymbol]?.[i18n.language] || store.currencySymbol;

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const toggleRow = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  // Filter products based on search input
  const filteredProducts =
    filter && !products
      ? (reduxProducts || []).filter(
          (product) =>
            (product.name &&
              product.name.toLowerCase().includes(filter.toLowerCase())) ||
            (product.sku &&
              product.sku.toLowerCase().includes(filter.toLowerCase()))
        )
      : _DATA.currentData();

  const ColorOptionsTable = ({ product, productId }) => {
    const [editing, setEditing] = useState({
      isEditing: false,
      rowId: null,
      field: null,
      values: {
        choice: "",
        price: "",
        quantity: "",
      },
    });

    const [isUpdating, setIsUpdating] = useState(false);

    // Add this state for the size/unified option checkbox
    const [hasSizeOption, setHasSizeOption] = useState(true);

    // Stock modal state
    const [openStockModal, setOpenStockModal] = useState(false);
    const [currentOptionPath, setCurrentOptionPath] = useState(null);
    const [stockData, setStockData] = useState({
      quantity: "",
    });

    // New modal for adding a complete option
    const [openAddOptionModal, setOpenAddOptionModal] = useState(false);
    const [newOptionData, setNewOptionData] = useState({
      optionName: "",
      color: "",
      isColor: false,
    });

    // Main Product Quantity and Price modal
    const [openMainProductQtyModal, setOpenMainProductQtyModal] =
      useState(false);
    const [mainProductQty, setMainProductQty] = useState("");
    const [mainProductPrice, setMainProductPrice] = useState("");

    const handleCloseStockModal = () => {
      setOpenStockModal(false);
      setStockData({
        quantity: "",
      });
    };

    const handleOpenStockModal = (colorIndex, colorOptionIndex, sizeIndex) => {
      setCurrentOptionPath({
        colorIndex,
        colorOptionIndex,
        sizeIndex,
      });
      setOpenStockModal(true);
    };

    const handleStockDataChange = (e) => {
      const { name, value, type, checked } = e.target;
      setStockData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    };

    // Main Product Quantity handlers
    const handleOpenMainProductQtyModal = () => {
      setMainProductQty(product.qty || "0");
      setMainProductPrice(product.price || "0");
      setOpenMainProductQtyModal(true);
    };

    const handleCloseMainProductQtyModal = () => {
      setOpenMainProductQtyModal(false);
    };

    const handleMainProductQtyChange = (e) => {
      setMainProductQty(e.target.value);
    };

    const handleMainProductPriceChange = (e) => {
      setMainProductPrice(e.target.value);
    };

    const handleUpdateMainProductQty = async () => {
      try {
        setIsUpdating(true);

        // Parse values safely, ensuring they are valid numbers
        const parsedQty = parseInt(mainProductQty) || 0;
        const parsedPrice = parseFloat(mainProductPrice) || 0;

        // Update the qty and price fields directly

        const updatedProduct = await workerAPI.updateProduct(product.id, {
          qty: parsedQty,
          price: parsedPrice,
        });
        dispatch(updateProduct(updatedProduct));
        apicache(account, products);
        // Show success message
        Swal.fire({
          icon: "success",
          title: t("Stock.StockTable.MainProductQty.successTitle"),
          confirmButtonText: t(
            "Stock.StockTable.MainProductQty.successTitle"
          ),
        });

        // Close modal
        handleCloseMainProductQtyModal();
      } catch (error) {
        console.error("Error updating product data:", error);
        Swal.fire({
          icon: "error",
          title: t("Stock.StockTable.MainProductQty.errorTitle"),
          text: error.message,
          confirmButtonText: t(
            "Stock.StockTable.MainProductQty.successTitle"
          ),
        });
      } finally {
        setIsUpdating(false);
      }
    };

    // Add Complete Option handlers
    const handleOpenAddOptionModal = () => {
      setOpenAddOptionModal(true);
    };

    const handleCloseAddOptionModal = () => {
      setOpenAddOptionModal(false);
      setNewOptionData({
        optionName: "",
        color: "",
        isColor: false,
      });
    };

    const handleNewOptionDataChange = (e) => {
      const { name, value, type, checked } = e.target;
      setNewOptionData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    };

    const handleAddNewOption = async () => {
      try {
        setIsUpdating(true);

        // Get current options or initialize empty array
        const currentOptions = product.options || [];

        // Create new color option object
        const newColorOption = {
          color: newOptionData.color,
          option: newOptionData.optionName,
        };

        // Check if we already have an entry for this color type
        const colorTypeExists = currentOptions.some(
          (option) => option.color === (newOptionData.isColor ? "1" : "0")
        );

        let updatedOptions = [...currentOptions];

        if (colorTypeExists) {
          // If this color type exists, find it and add to its colorOption array
          updatedOptions = currentOptions.map((option) => {
            if (option.color === (newOptionData.isColor ? "1" : "0")) {
              // Add new option to existing colorOption array
              const updatedOption = {
                ...option,
                colorOption: Array.isArray(option.colorOption)
                  ? [...option.colorOption, newColorOption]
                  : [newColorOption], // Handle case where colorOption might not be an array yet
                title: newOptionData.isColor ? "1" : "2", // Set title based on checkbox state
              };

              // Add advancedOptionsEnabled field if it's a color option
              if (newOptionData.isColor) {
                updatedOption.advancedOptionsEnabled = false;
              }

              return updatedOption;
            }
            return option;
          });
        } else {
          // If this color type doesn't exist yet, create a new entry
          const newOption = {
            color: newOptionData.isColor ? "1" : "0",
            colorOption: [newColorOption], // Start with an array containing the new option
            title: newOptionData.isColor ? "1" : "2", // Set title based on checkbox state
          };

          // Add advancedOptionsEnabled field if it's a color option
          if (newOptionData.isColor) {
            newOption.advancedOptionsEnabled = false;
          }

          updatedOptions = [...currentOptions, newOption];
        }

        const updatedProduct = await workerAPI.updateProduct(product.id, {
          options: updatedOptions,
        });
        dispatch(updateProduct(updatedProduct));

        apicache(account, products);

        // Close modal and reset form
        handleCloseAddOptionModal();

        // Show success message
        Swal.fire({
          icon: "success",
          title: t("Stock.StockTable.AddOption.successTitle"),
          confirmButtonText: t("Stock.StockTable.AddOption.confirmText"),
        });

        // Update local state
        setOptions(updatedOptions);
      } catch (error) {
        console.error("Error adding option:", error);
        Swal.fire({
          icon: "error",
          title: t("Stock.StockTable.AddOption.errorTitle"),
          text: error.message,
          confirmButtonText: t("Stock.StockTable.AddOption.confirmText"),
        });
      } finally {
        setIsUpdating(false);
      }
    };

    const handleAddStock = async () => {
      try {
        setIsUpdating(true);

        // Validate stock data input
        const stockToAdd = parseInt(stockData.quantity);
        if (isNaN(stockToAdd) || stockToAdd <= 0) {
          throw new Error("الرجاء إدخال كمية صالحة");
        }

        // Create a copy of the options to modify
        const updatedOptions = [...options];

        const { colorIndex, colorOptionIndex, sizeIndex, isDefaultQuantity } =
          currentOptionPath || {};

        // Check if we're updating the main product quantity
        if (
          colorIndex === undefined &&
          colorOptionIndex === undefined &&
          sizeIndex === undefined
        ) {
          // Update the main product qty field with safe parsing
          const currentQty = parseInt(product.qty || 0);
          const newQty = currentQty + stockToAdd;

          const updatedProduct = workerAPI.updateProduct(product.id, {
            qty: newQty,
          });
          dispatch(updateProduct(updatedProduct));
          apicache(account, products);
        } else if (isDefaultQuantity) {
          // Handle updating the default quantity for a color option
          if (
            colorIndex === undefined ||
            updatedOptions[colorIndex] === undefined
          ) {
            throw new Error("مسار خيار المنتج غير صالح");
          }

          // Get the specific color option
          const colorOption = Array.isArray(
            updatedOptions[colorIndex].colorOption
          )
            ? updatedOptions[colorIndex].colorOption[colorOptionIndex]
            : updatedOptions[colorIndex].colorOption;

          if (!colorOption) {
            throw new Error("خيار اللون غير صالح");
          }

          // Get current quantity or initialize to 0
          const currentQty = parseInt(colorOption.quantity || 0);

          // Update the quantity
          if (Array.isArray(updatedOptions[colorIndex].colorOption)) {
            updatedOptions[colorIndex].colorOption[colorOptionIndex].quantity =
              currentQty + stockToAdd;
          } else {
            updatedOptions[colorIndex].colorOption.quantity =
              currentQty + stockToAdd;
          }

          const updatedProduct = await workerAPI.updateProduct(product.id, {
            options: updatedOptions,
          });

          dispatch(updateProduct(updatedProduct));

          // Update local state
          setOptions(updatedOptions);
        } else {
          // Original code for updating size quantities
          // Ensure the path exists
          if (
            colorIndex === undefined ||
            updatedOptions[colorIndex] === undefined
          ) {
            throw new Error("مسار خيار المنتج غير صالح");
          }

          // Get the specific path to update
          const colorOption = Array.isArray(
            updatedOptions[colorIndex].colorOption
          )
            ? updatedOptions[colorIndex].colorOption[colorOptionIndex]
            : updatedOptions[colorIndex].colorOption;

          if (
            !colorOption ||
            !colorOption.sizeColor ||
            !colorOption.sizeColor[sizeIndex]
          ) {
            throw new Error("مسار المقاس غير صالح");
          }

          // Current size details
          const currentSize = colorOption.sizeColor[sizeIndex];
          const currentQty = parseInt(currentSize.quantity || 0);

          // Just update the quantity of the current size
          colorOption.sizeColor[sizeIndex].quantity = currentQty + stockToAdd;
          const updatedProduct = await workerAPI.updateProduct(product.id, {
            options: updatedOptions,
          });
          dispatch(updateProduct(updatedProduct));

          // Update local state with the new values
          setOptions(updatedOptions);
        }

        // Close modal and reset form
        handleCloseStockModal();

        // Show success message
        Swal.fire({
          icon: "success",
          title: t("Stock.StockTable.handleSaveNewSize.success.withoutSize"),
          confirmButtonText: t(
            "Stock.StockTable.handleSaveNewSize.confirmButton"
          ),
        });
      } catch (error) {
        console.error("Error updating stock:", error);
        Swal.fire({
          icon: "error",
          title: t("Stock.StockTable.handleSaveNewSize.error.title"),
          text: error.message,
          confirmButtonText: t(
            "Stock.StockTable.handleSaveNewSize.confirmButton"
          ),
        });
      } finally {
        setIsUpdating(false);
      }
    };

    const handleModifyClick = (sizeId, sizeData) => {
      setEditing({
        isEditing: true,
        rowId: sizeId,
        field: null,
        values: {
          choice: sizeData.choice,
          price: sizeData.price || "",
          quantity: sizeData.quantity || "",
        },
      });
    };

    const handleCancel = () => {
      setEditing({
        isEditing: false,
        rowId: null,
        field: null,
        values: { choice: "", price: "", quantity: "" },
      });
    };

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setEditing((prev) => ({
        ...prev,
        values: {
          ...prev.values,
          [name]: value,
        },
      }));
    };

    // Safe check for options
    const [options, setOptions] = useState(product.options || []);

    const handleSave = async () => {
      try {
        // Parse the row ID to get indices
        const [colorIndex, colorOptionIndex, sizeIndex] = editing.rowId
          .split("-")
          .map(Number);

        // Create a copy of the options to modify
        const updatedOptions = [...options];

        // Get the specific path to update
        const colorOption = Array.isArray(
          updatedOptions[colorIndex].colorOption
        )
          ? updatedOptions[colorIndex].colorOption[colorOptionIndex]
          : updatedOptions[colorIndex].colorOption;

        // Convert price and quantity values to numbers, handling any potential parsing issues
        const parsedPrice = parseFloat(editing.values.price) || 0;
        const parsedQuantity = parseInt(editing.values.quantity) || 0;

        // Update the specific size with edited values
        colorOption.sizeColor[sizeIndex] = {
          ...colorOption.sizeColor[sizeIndex],
          price: parsedPrice,
          quantity: parsedQuantity,
        };

        // Update the document in Firebase
        const updatedProduct = workerAPI.updateProduct(product.id, {
          options: updatedOptions,
        });
        dispatch(updateProduct(updatedProduct));
        apicache(account, products);
        // Update local state with the new values
        setOptions(updatedOptions);

        // Exit edit mode
        setEditing({
          isEditing: false,
          rowId: "",
          values: { price: "", quantity: "" },
        });

        // Show success message
        Swal.fire({
          icon: "success",
          title: t("Stock.StockTable.MainProductQty.successTitle"),
          confirmButtonText: t("Stock.StockTable.MainProductQty.errorConfirm"),
        });
      } catch (error) {
        console.error("Error updating product:", error);
        Swal.fire({
          icon: "error",
          title: t("Stock.StockTable.MainProductQty.errorTitle"),
          text: error.message,
          confirmButtonText: t("Stock.StockTable.MainProductQty.errorConfirm"),
        });
      }
    };

    // Debug function to help understand the data structure
    const debugOptions = () => {
      return options && options.length > 0;
    };

    const hasOptions = debugOptions();

    // Stock Modal Component
    const StockModal = () => (
      <Modal
        open={openStockModal}
        onClose={handleCloseStockModal}
        aria-labelledby="stock-modal-title"
        aria-describedby="stock-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            // direction: "rtl",
          }}
        >
          <div className="flex justify-between items-center mb-4">
            <h3
              id="stock-modal-title"
              className="text-lg font-semibold text-[#9e65bb]"
            >
              {t("Stock.StockTable.StockModal.title")}
            </h3>
            <button
              onClick={handleCloseStockModal}
              className="p-1 rounded-full hover:bg-gray-100"
              tabIndex="0"
              aria-label={t("Stock.StockTable.StockModal.closeAriaLabel")}
            >
              <X size={20} />
            </button>
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (stockData.quantity) handleAddStock();
            }}
            className="space-y-4"
          >
            <div>
              <label
                htmlFor="quantity"
                className="block mb-1 text-sm font-medium text-gray-700"
              >
                {t("Stock.StockTable.StockModal.form.quantityLabel")}
              </label>
              <input
                type="text"
                id="quantity"
                name="quantity"
                value={stockData.quantity}
                onChange={handleStockDataChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-200"
                inputMode="numeric"
                pattern="[0-9]*"
                min="1"
                required
                autoFocus
              />
            </div>

            <div className="pt-2">
              <button
                type="submit"
                disabled={!stockData.quantity}
                className={`w-full py-2 px-4 rounded-md font-medium text-white ${
                  !stockData.quantity
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#9b59bf]  hover:bg-[#814a9f] "
                }`}
              >
                {isUpdating
                  ? t("Stock.StockTable.StockModal.form.submit.adding")
                  : t("Stock.StockTable.StockModal.form.submit.add")}
              </button>
            </div>
          </form>
        </Box>
      </Modal>
    );

    // Main Product Quantity Modal
    const MainProductQtyModal = () => (
      <Modal
        open={openMainProductQtyModal}
        onClose={handleCloseMainProductQtyModal}
        aria-labelledby="main-product-qty-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            // direction: "rtl",
          }}
        >
          <div className="flex justify-between items-center mb-4">
            <h3
              id="main-product-qty-modal-title"
              className="text-lg font-semibold text-[#9e65bb]"
            >
              {t("Stock.StockTable.MainProductQtyModal.title")}
            </h3>
            <button
              onClick={handleCloseMainProductQtyModal}
              className="p-1 rounded-full hover:bg-gray-100"
              tabIndex="0"
              aria-label={t(
                "Stock.StockTable.MainProductQtyModal.closeAriaLabel"
              )}
            >
              <X size={20} />
            </button>
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (mainProductQty !== "" && mainProductPrice !== "") {
                handleUpdateMainProductQty();
              }
            }}
            className="space-y-4"
          >
            <div>
              <label
                htmlFor="mainPrice"
                className="block mb-1 text-sm font-medium text-gray-700"
              >
                {t("Stock.StockTable.MainProductQtyModal.form.priceLabel")}
              </label>
              <input
                type="text"
                inputMode="decimal"
                id="mainPrice"
                name="mainPrice"
                value={mainProductPrice}
                onChange={handleMainProductPriceChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-200"
                pattern="[0-9]*\.?[0-9]*"
                min="0"
                required
                autoFocus
              />
            </div>

            <div>
              <label
                htmlFor="mainQuantity"
                className="block mb-1 text-sm font-medium text-gray-700"
              >
                {t("Stock.StockTable.MainProductQtyModal.form.quantityLabel")}
              </label>
              <input
                type="text"
                inputMode="numeric"
                id="mainQuantity"
                name="mainQuantity"
                value={mainProductQty}
                onChange={handleMainProductQtyChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-200"
                pattern="[0-9]*"
                min="0"
                required
              />
            </div>

            <div className="pt-2">
              <button
                type="submit"
                disabled={mainProductQty === "" || mainProductPrice === ""}
                className={`w-full py-2 px-4 rounded-md font-medium text-white ${
                  mainProductQty === "" || mainProductPrice === ""
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#9b59bf]  hover:bg-[#814a9f] "
                }`}
              >
                {isUpdating
                  ? t("Stock.StockTable.MainProductQtyModal.form.loading")
                  : t("Stock.StockTable.MainProductQtyModal.form.submitButton")}
              </button>
            </div>
          </form>
        </Box>
      </Modal>
    );

    // Add Option Modal Component
    const AddOptionModal = () => (
      <Modal
        open={openAddOptionModal}
        onClose={handleCloseAddOptionModal}
        aria-labelledby="add-option-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            // direction: "rtl",
          }}
        >
          <div className="flex justify-between items-center mb-4">
            <h3
              id="add-option-modal-title"
              className="text-lg font-semibold text-[#9e65bb]"
            >
              {t("Stock.StockTable.AddOptionModal.title")}
            </h3>
            <button
              onClick={handleCloseAddOptionModal}
              className="p-1 rounded-full hover:bg-gray-100"
              tabIndex="0"
              aria-label={t("Stock.StockTable.AddOptionModal.closeAriaLabel")}
            >
              <X size={20} />
            </button>
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (newOptionData.optionName) handleAddNewOption();
            }}
            className="space-y-4"
          >
            <div>
              <label
                htmlFor="optionName"
                className="block mb-1 text-sm font-medium text-gray-700"
              >
                {t("Stock.StockTable.AddOptionModal.form.optionNameLabel")}
              </label>
              <input
                type="text"
                id="optionName"
                name="optionName"
                value={newOptionData.optionName}
                onChange={handleNewOptionDataChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-200"
                required
                autoFocus
              />
            </div>

            <div className="flex items-center mb-3">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={newOptionData.isColor}
                    onChange={handleNewOptionDataChange}
                    name="isColor"
                  />
                }
                label={t("Stock.StockTable.AddOptionModal.form.isColorLabel")}
                labelPlacement="end"
              />
            </div>

            {newOptionData.isColor && (
              <div>
                <label
                  htmlFor="color"
                  className="block mb-1 text-sm font-medium text-gray-700"
                >
                  {t("Stock.StockTable.AddOptionModal.form.colorLabel")}
                </label>
                <div className="flex items-center gap-2">
                  <input
                    type="color"
                    id="color"
                    name="color"
                    value={newOptionData.color}
                    onChange={handleNewOptionDataChange}
                    className="h-10 w-10 border border-gray-300 rounded-md cursor-pointer"
                  />
                  <span className="text-gray-600">{newOptionData.color}</span>
                </div>
              </div>
            )}

            <div className="pt-2">
              <button
                type="submit"
                disabled={!newOptionData.optionName}
                className={`w-full py-2 px-4 rounded-md font-medium text-white ${
                  !newOptionData.optionName
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#9b59bf]  hover:bg-[#814a9f] "
                }`}
              >
                {isUpdating
                  ? t("Stock.StockTable.AddOptionModal.form.loading")
                  : t("Stock.StockTable.AddOptionModal.form.submitButton")}
              </button>
            </div>
          </form>
        </Box>
      </Modal>
    );

    // Modal state for adding new size option
    const [addSizeModalOpen, setAddSizeModalOpen] = useState(false);
    const [newSizeData, setNewSizeData] = useState({
      choice: "",
      price: "",
      quantity: "",
    });
    const [currentColorIndices, setCurrentColorIndices] = useState(null);

    // Added state to track if adding to product directly or to a specific color option
    const [isAddingToProduct, setIsAddingToProduct] = useState(false);

    // Helper functions for dynamic UI text
    const getModalTitle = () => {
      return hasSizeOption
        ? t("Stock.StockTable.AddSizeOptionModal.titleAdd1")
        : t("Stock.StockTable.AddSizeOptionModal.titleAdd2");
    };

    const getButtonText = () => {
      if (hasSizeOption) {
        return isUpdating
          ? t("Stock.StockTable.AddSizeOptionModal.form.submitButtonaddLoading")
          : t("Stock.StockTable.AddSizeOptionModal.form.submitButtonAddsize");
      } else {
        return isUpdating
          ? t("Stock.StockTable.AddSizeOptionModal.form.submitButtonaddLoading")
          : t("Stock.StockTable.AddSizeOptionModal.form.submitButtonAddStock");
      }
    };

    const handleAddNewSizeOption = (colorIndex, colorOptionIndex) => {
      // If both indices are 0 and called from the header button
      if (
        colorIndex === 0 &&
        colorOptionIndex === 0 &&
        !expandedRows[product.id]
      ) {
        setIsAddingToProduct(true);

        // Show modal to select which color option to add to
        if (hasOptions && options.length > 0) {
          // Open a different modal to select which option to add to
          setSelectOptionModalOpen(true);
        } else {
          // If no options exist, proceed to add to the main product
          setCurrentColorIndices({ colorIndex: 0, colorOptionIndex: 0 });
          setHasSizeOption(true); // Default to size option
          setAddSizeModalOpen(true);
        }
      } else {
        // Normal flow when adding to a specific color option
        setIsAddingToProduct(false);
        setCurrentColorIndices({ colorIndex, colorOptionIndex });
        setHasSizeOption(true); // Default to size option
        setAddSizeModalOpen(true);
      }
    };

    // New modal state
    const [selectOptionModalOpen, setSelectOptionModalOpen] = useState(false);
    const [selectedOptionIndex, setSelectedOptionIndex] = useState({
      colorIndex: 0,
      colorOptionIndex: 0,
    });

    const handleCloseSelectOptionModal = () => {
      setSelectOptionModalOpen(false);
    };

    const handleProceedToAddSize = () => {
      setSelectOptionModalOpen(false);
      setCurrentColorIndices(selectedOptionIndex);
      setHasSizeOption(true); // Default to size option
      setAddSizeModalOpen(true);
    };

    const handleCloseSizeModal = () => {
      setAddSizeModalOpen(false);
      setNewSizeData({
        choice: "",
        price: "",
        quantity: "",
      });
      setHasSizeOption(true); // Reset to default state
    };

    const handleNewSizeDataChange = (e) => {
      const { name, value } = e.target;
      setNewSizeData((prev) => ({
        ...prev,
        [name]: value,
      }));
    };

    const handleSaveNewSize = async () => {
      try {
        setIsUpdating(true);
        // Ensure currentColorIndices is valid
        if (!currentColorIndices) {
          throw new Error("No color option selected");
        }

        const { colorIndex, colorOptionIndex } = currentColorIndices;

        // Create a copy of the options to modify
        const updatedOptions = [...options];

        // Get the specific path to update
        const colorOption = Array.isArray(
          updatedOptions[colorIndex].colorOption
        )
          ? updatedOptions[colorIndex].colorOption[colorOptionIndex]
          : updatedOptions[colorIndex].colorOption;

        // Parse values safely
        const parsedPrice = parseFloat(newSizeData.price) || product.price;
        const parsedQuantity = parseInt(newSizeData.quantity) || 0;

        if (hasSizeOption) {
          // Add new size option
          colorOption.sizeColor.push({
            choice: newSizeData.choice.trim(),
            price: parsedPrice,
            quantity: parsedQuantity,
          });
        } else {
          // Just add the quantity directly to the color option
          colorOption.quantity = parsedQuantity;
          if (newSizeData.price) {
            colorOption.price = parsedPrice;
          }
        }

        // Update the document in Firebase
        const updatedProduct = await workerAPI.updateProduct(product.id, {
          options: updatedOptions,
        });
        dispatch(updateProduct(updatedProduct));
        apicache(account, products);
        // Update local state with the new values
        setOptions(updatedOptions);

        // Close modal and reset form
        handleCloseSizeModal();

        // Show success message
        Swal.fire({
          icon: "success",
          title: hasSizeOption
            ? t("Stock.StockTable.handleSaveNewSize.success.withSize")
            : t("Stock.StockTable.handleSaveNewSize.success.withoutSize"),
          confirmButtonText: t(
            "Stock.StockTable.handleSaveNewSize.confirmButton"
          ),
        });
      } catch (error) {
        console.error("Error adding size/stock option:", error);
        Swal.fire({
          icon: "error",
          title: t("Stock.StockTable.handleSaveNewSize.error.title"),
          text: error.message,
          confirmButtonText: t(
            "Stock.StockTable.handleSaveNewSize.confirmButton"
          ),
        });
      } finally {
        setIsUpdating(false);
      }
    };

    // Add Size Option Modal Component
    const AddSizeOptionModal = () => (
      <Modal
        open={addSizeModalOpen}
        onClose={handleCloseSizeModal}
        aria-labelledby="add-size-modal-title"
        aria-describedby="add-size-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            // direction: "rtl",
          }}
        >
          <div className="flex justify-between items-center mb-4">
            <h3
              id="add-size-modal-title"
              className="text-lg font-semibold text-[#9e65bb]"
            >
              {getModalTitle()}
            </h3>
            <button
              onClick={handleCloseSizeModal}
              className="p-1 rounded-full hover:bg-gray-100"
              tabIndex="0"
              aria-label={t(
                "Stock.StockTable.AddSizeOptionModal.closeAriaLabel"
              )}
            >
              <X size={20} />
            </button>
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (hasSizeOption ? newSizeData.choice : true)
                handleSaveNewSize();
            }}
            className="space-y-4"
          >
            <div className="flex items-center mb-3">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={hasSizeOption}
                    onChange={(e) => setHasSizeOption(e.target.checked)}
                    name="hasSizeOption"
                  />
                }
                label={t(
                  "Stock.StockTable.AddSizeOptionModal.form.hasSizeOptionLabel"
                )}
                labelPlacement="end"
              />
            </div>

            {hasSizeOption && (
              <div>
                <label
                  htmlFor="choice"
                  className="block mb-1 text-sm font-medium text-gray-700"
                >
                  {t("Stock.StockTable.AddSizeOptionModal.form.choiceLabel")}
                </label>
                <input
                  type="text"
                  id="choice"
                  name="choice"
                  value={newSizeData.choice}
                  onChange={handleNewSizeDataChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-200"
                  required={hasSizeOption}
                  autoFocus
                />
              </div>
            )}

            <div>
              <label
                htmlFor="price"
                className="block mb-1 text-sm font-medium text-gray-700"
              >
                {t("Stock.StockTable.AddSizeOptionModal.form.priceLabel")}
              </label>
              <input
                type="text"
                inputMode="decimal"
                id="price"
                name="price"
                value={newSizeData.price}
                onChange={handleNewSizeDataChange}
                pattern="[0-9]*\.?[0-9]*"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-200"
                placeholder={t(
                  "Stock.StockTable.AddSizeOptionModal.form.pricePlaceholder",
                  { price: product.price }
                )}
              />
            </div>

            <div>
              <label
                htmlFor="quantity"
                className="block mb-1 text-sm font-medium text-gray-700"
              >
                {t("Stock.StockTable.AddSizeOptionModal.form.quantityLabel")}
              </label>
              <input
                type="text"
                inputMode="numeric"
                id="quantity"
                name="quantity"
                value={newSizeData.quantity}
                onChange={handleNewSizeDataChange}
                pattern="[0-9]*"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-200"
                min="0"
                required
              />
            </div>

            <div className="pt-2">
              <button
                type="submit"
                disabled={hasSizeOption && !newSizeData.choice}
                className={`w-full py-2 px-4 rounded-md font-medium text-white ${
                  hasSizeOption && !newSizeData.choice
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#9b59bf]  hover:bg-[#814a9f] "
                }`}
              >
                {getButtonText()}
              </button>
            </div>
          </form>
        </Box>
      </Modal>
    );

    // Select Option Modal Component
    const SelectOptionModal = () => (
      <Modal
        open={selectOptionModalOpen}
        onClose={handleCloseSelectOptionModal}
        aria-labelledby="select-option-modal-title"
        aria-describedby="select-option-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            // direction: "rtl",
          }}
        >
          <div className="flex justify-between items-center mb-4">
            <h3
              id="select-option-modal-title"
              className="text-lg font-semibold text-[#9e65bb]"
            >
              {t("Stock.StockTable.SelectOptionModal.title")}
            </h3>
            <button
              onClick={handleCloseSelectOptionModal}
              className="p-1 rounded-full hover:bg-gray-100"
              tabIndex="0"
              aria-label={t(
                "Stock.StockTable.SelectOptionModal.closeAriaLabel"
              )}
            >
              <X size={20} />
            </button>
          </div>

          <div className="space-y-4">
            <div className="border border-purple-100 rounded-lg divide-y divide-purple-100">
              {/* Option for the main product */}
              <div
                className="p-3 hover:bg-purple-50 cursor-pointer flex items-center"
                onClick={() => {
                  setSelectedOptionIndex({
                    colorIndex: 0,
                    colorOptionIndex: 0,
                  });
                  handleProceedToAddSize();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setSelectedOptionIndex({
                      colorIndex: 0,
                      colorOptionIndex: 0,
                    });
                    handleProceedToAddSize();
                  }
                }}
                tabIndex="0"
                role="button"
                aria-label={t(
                  "Stock.StockTable.SelectOptionModal.defaultProductAriaLabel"
                )}
              >
                <div className="flex items-center gap-2 w-full">
                  <span
                    className="w-4 h-4 rounded-full"
                    style={{ backgroundColor: "#ddd" }}
                  ></span>
                  <span className="font-medium">
                    {t(
                      "Stock.StockTable.SelectOptionModal.defaultProductLabel"
                    )}
                  </span>
                </div>
              </div>

              {/* List all available color options */}
              {hasOptions &&
                options.map((option, colorIndex) => {
                  const hasColorFlag = option.color === "1";

                  if (hasColorFlag) {
                    // Display color options
                    const colorOptionsArray = Array.isArray(option.colorOption)
                      ? option.colorOption
                      : option.colorOption
                      ? [option.colorOption]
                      : [];

                    return colorOptionsArray.map(
                      (colorOption, colorOptionIndex) => {
                        if (!colorOption) return null;

                        const colorName =
                          colorOption?.option ||
                          t(
                            "Stock.StockTable.SelectOptionModal.colorTitleFallback"
                          );
                        const colorHex = colorOption?.color || "#ddd";

                        return (
                          <div
                            key={`select-color-${colorIndex}-${colorOptionIndex}`}
                            className="p-3 hover:bg-purple-50 cursor-pointer flex items-center"
                            onClick={() => {
                              setSelectedOptionIndex({
                                colorIndex,
                                colorOptionIndex,
                              });
                              handleProceedToAddSize();
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                setSelectedOptionIndex({
                                  colorIndex,
                                  colorOptionIndex,
                                });
                                handleProceedToAddSize();
                              }
                            }}
                            tabIndex="0"
                            role="button"
                            aria-label={t(
                              "Stock.StockTable.SelectOptionModal.selectColorAriaLabel",
                              { colorName }
                            )}
                          >
                            <div className="flex items-center gap-2 w-full">
                              <span
                                className="w-4 h-4 rounded-full"
                                style={{ backgroundColor: colorHex }}
                              ></span>
                              <span className="font-medium">
                                {colorName ||
                                  t(
                                    "Stock.StockTable.SelectOptionModal.colorTitleFallback"
                                  )}
                              </span>
                            </div>
                          </div>
                        );
                      }
                    );
                  } else {
                    // Display non-color options
                    const nonColorOptions = Array.isArray(option.colorOption)
                      ? option.colorOption
                      : option.colorOption
                      ? [option.colorOption]
                      : [];

                    return nonColorOptions.map((optionItem, optionIndex) => {
                      const optionName =
                        optionItem?.option ||
                        t(
                          "Stock.StockTable.SelectOptionModal.nonColorOptionFallback"
                        );

                      return (
                        <div
                          key={`select-option-${colorIndex}-${optionIndex}`}
                          className="p-3 hover:bg-purple-50 cursor-pointer flex items-center"
                          onClick={() => {
                            setSelectedOptionIndex({
                              colorIndex,
                              colorOptionIndex: optionIndex,
                            });
                            handleProceedToAddSize();
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              setSelectedOptionIndex({
                                colorIndex,
                                colorOptionIndex: optionIndex,
                              });
                              handleProceedToAddSize();
                            }
                          }}
                          tabIndex="0"
                          role="button"
                          aria-label={t(
                            "Stock.StockTable.SelectOptionModal.selectOptionAriaLabel",
                            {
                              label:
                                typeof optionName === "number"
                                  ? t(
                                      "Stock.StockTable.SelectOptionModal.sizeLabel",
                                      { size: optionName }
                                    )
                                  : optionName ||
                                    t(
                                      "Stock.StockTable.SelectOptionModal.nonColorOptionFallback"
                                    ),
                            }
                          )}
                        >
                          <div className="flex items-center gap-2 w-full">
                            <span className="font-medium">
                              {typeof optionName === "number"
                                ? `${t(
                                    "Stock.StockTable.SelectOptionModal.selectSizeAriaLabel",
                                    { optionName }
                                  )}`
                                : optionName ||
                                  t(
                                    "Stock.StockTable.SelectOptionModal.nonColorOptionFallback"
                                  )}
                            </span>
                          </div>
                        </div>
                      );
                    });
                  }
                })}
            </div>
          </div>
        </Box>
      </Modal>
    );

    // Function to render available sizes for a specific color option
    const renderSizeOptions = (colorOption, parentIndices) => {
      const sizeOptions = colorOption?.sizeColor || [];
      const [colorIndex, colorOptionIndex] = parentIndices || [];

      if (!sizeOptions || sizeOptions.length === 0) {
        const hasDefaultQuantity =
          colorOption &&
          colorOption.quantity !== undefined &&
          !isNaN(parseInt(colorOption.quantity, 10));

        if (hasDefaultQuantity) {
          // Display the default quantity in a table format similar to size options
          return (
            <div className="overflow-x-auto">
              <div className="grid grid-cols-5 bg-purple-50 rounded-t-lg p-3 border border-purple-100 border-b-0 dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                <div className="text-right text-sm font-medium text-[#9e65bb]">
                  {t("Stock.StockTable.SizeOptions.tableHeaders.price")}
                </div>
                <div className="text-right text-sm font-medium text-[#9e65bb]">
                  {t("Stock.StockTable.SizeOptions.tableHeaders.quantity")}
                </div>
                <div className="text-right text-sm font-medium text-[#9e65bb]">
                  {t("Stock.StockTable.SizeOptions.tableHeaders.stock")}
                </div>
              </div>

              <div className="border border-purple-100 rounded-b-lg divide-y divide-purple-100 bg-white">
                <div className="grid grid-cols-5 p-3 items-center bg-white hover:bg-purple-50 transition-colors">
                  <div className="text-gray-700">
                    <span className="bg-[#faf1ff] text-[#9e65bb] px-3 py-1 rounded-lg">
                      {colorOption.price || product.price}{" "}
                      {localizedCurrency || t("ui.dzd")}
                    </span>
                  </div>
                  <div className="text-gray-700">
                    {colorOption.quantity || 0}
                  </div>

                  <div>
                    <button
                      onClick={() => {
                        setStockData({ quantity: "" });
                        setCurrentOptionPath({
                          colorIndex,
                          colorOptionIndex,
                          isDefaultQuantity: true,
                        });
                        setOpenStockModal(true);
                      }}
                      className="px-3 py-1.5 rounded-md text-xs font-medium bg-green-50 text-green-700 flex items-center gap-1 justify-center"
                      tabIndex="0"
                      aria-label={t(
                        "Stock.StockTable.SizeOptions.buttons.addStock"
                      )}
                    >
                      <Plus size={16} />
                      {t("Stock.StockTable.SizeOptions.buttons.addStock")}
                    </button>
                  </div>
                </div>
              </div>

              {/* Button to add size options below the table */}
              {/* <div className="mt-4 text-center">
                <button
                  onClick={() =>
                    handleAddNewSizeOption(colorIndex, colorOptionIndex)
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleAddNewSizeOption(colorIndex, colorOptionIndex);
                    }
                  }}
                  className="px-3 py-1.5 rounded-md text-xs font-medium bg-[#9b59bf]  text-white hover:bg-[#814a9f]  transition-colors flex items-center gap-1 mx-auto"
                  tabIndex="0"
                  aria-label="إضافة مقاس جديد"
                >
                  <Plus size={16} />
                  إضافة مقاس/مخزون
                </button>
              </div> */}
            </div>
          );
        } else {
          // Original message for no available options
          return (
            <div className="text-center py-4 border border-purple-100 rounded-lg bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d]">
              <p className="text-gray-500 mb-3">
                {t("Stock.StockTable.SizeOptions.noSizesMessage")}
              </p>

              {/* Button to add new size options */}
              <button
                onClick={() =>
                  handleAddNewSizeOption(colorIndex, colorOptionIndex)
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleAddNewSizeOption(colorIndex, colorOptionIndex);
                  }
                }}
                className="px-3 py-1.5 rounded-md text-xs font-medium bg-[#9b59bf]  text-white hover:bg-[#814a9f]  transition-colors flex items-center gap-1 mx-auto"
                tabIndex="0"
                aria-label={t(
                  "Stock.StockTable.SizeOptions.ariaLabels.addSize"
                )}
              >
                <Plus size={16} />
                {t("Stock.StockTable.SizeOptions.buttons.addSizeOrStock")}
              </button>
            </div>
          );
        }
      }

      // Original code for rendering size options
      return (
        <div className="overflow-x-auto">
          <div className="grid grid-cols-5 bg-purple-50 rounded-t-lg p-3 border border-purple-100 border-b-0">
            <div className="text-right text-sm font-medium text-[#9e65bb]">
              {t("Stock.StockTable.SizeOptions.tableHeaders.choice")}
            </div>
            <div className="text-right text-sm font-medium text-[#9e65bb]">
              {t("Stock.StockTable.SizeOptions.tableHeaders.price")}
            </div>
            <div className="text-right text-sm font-medium text-[#9e65bb]">
              {t("Stock.StockTable.SizeOptions.tableHeaders.quantity")}
            </div>
            <div className="text-right text-sm font-medium text-[#9e65bb]">
              {t("Stock.StockTable.SizeOptions.tableHeaders.actions")}
            </div>
            <div className="text-right text-sm font-medium text-[#9e65bb]">
              {t("Stock.StockTable.SizeOptions.tableHeaders.stock")}
            </div>
          </div>

          <div className="border border-purple-100 rounded-b-lg divide-y divide-purple-100 bg-white">
            {sizeOptions.map((size, sizeIndex) => {
              if (!size) return null;

              const isEditingRow =
                editing.isEditing &&
                editing.rowId ===
                  `${colorIndex}-${colorOptionIndex}-${sizeIndex}`;

              return (
                <div
                  key={`size-${sizeIndex}`}
                  className={`grid grid-cols-5 p-3 items-center ${
                    sizeIndex % 2 === 0 ? "bg-white" : "bg-gray-50"
                  } hover:bg-purple-50 transition-colors`}
                >
                  <div className="font-medium text-gray-700">{size.choice}</div>

                  <div className="text-gray-700">
                    {isEditingRow ? (
                      <input
                        type="text"
                        inputMode="decimal"
                        name="price"
                        value={editing.values.price}
                        onChange={handleInputChange}
                        className="border px-2 rounded w-[80%]"
                      />
                    ) : (
                      <span className="bg-[#faf1ff] text-[#9e65bb] px-3 py-1 rounded-lg">
                        {size.price || product.price}{" "}
                        {localizedCurrency || t("ui.dzd")}
                      </span>
                    )}
                  </div>

                  <div className="text-gray-700">{size.quantity || 0}</div>

                  <div className="text-gray-700">
                    {isEditingRow ? (
                      <div className="flex gap-2 justify-start">
                        <button
                          onClick={() => handleSave()}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              handleSave();
                            }
                          }}
                          className="px-3 py-1.5 rounded-md text-xs font-medium bg-green-50 text-green-700"
                          tabIndex="0"
                          aria-label={t(
                            "Stock.StockTable.SizeOptions.ariaLabels.saveChanges"
                          )}
                        >
                          {t("Stock.StockTable.SizeOptions.buttons.save")}
                        </button>
                        <button
                          onClick={handleCancel}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              handleCancel();
                            }
                          }}
                          className="px-3 py-1.5 rounded-md text-xs font-medium bg-red-50 text-red-700"
                          tabIndex="0"
                          aria-label={t(
                            "Stock.StockTable.SizeOptions.ariaLabels.cancelChanges"
                          )}
                        >
                          {t("Stock.StockTable.SizeOptions.buttons.cancel")}
                        </button>
                      </div>
                    ) : (
                      <button
                        onClick={() =>
                          handleModifyClick(
                            `${colorIndex}-${colorOptionIndex}-${sizeIndex}`,
                            size
                          )
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleModifyClick(
                              `${colorIndex}-${colorOptionIndex}-${sizeIndex}`,
                              size
                            );
                          }
                        }}
                        className="px-3 py-1.5 rounded-md text-xs font-medium bg-blue-50 text-blue-700"
                        tabIndex="0"
                        aria-label={t(
                          "Stock.StockTable.SizeOptions.ariaLabels.editSize"
                        )}
                      >
                        {t("Stock.StockTable.SizeOptions.buttons.edit")}
                      </button>
                    )}
                  </div>

                  <div>
                    <button
                      onClick={() =>
                        handleOpenStockModal(
                          colorIndex,
                          colorOptionIndex,
                          sizeIndex
                        )
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          handleOpenStockModal(
                            colorIndex,
                            colorOptionIndex,
                            sizeIndex
                          );
                        }
                      }}
                      className="px-3 py-1.5 rounded-md text-xs font-medium bg-green-50 text-green-700 flex items-center gap-1 justify-center"
                      tabIndex="0"
                      aria-label={t(
                        "Stock.StockTable.SizeOptions.ariaLabels.addStockToSize"
                      )}
                    >
                      <Plus size={16} />
                      {t("Stock.StockTable.SizeOptions.buttons.addStock")}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    };

    // Render default product option if no options exist
    const renderDefaultProductOption = () => {
      return (
        <div
          key="default-product-option"
          className="mb-4 bg-purple-50 dark:!bg-[#181819] p-4 rounded-lg border border-purple-100 dark:!border-[#3c3a3d]"
        >
          <h5 className="text-sm font-medium text-[#9e65bb] mb-3 border-b border-purple-100 dark:border-[#3c3a3d] pb-2 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span
                className="w-4 h-4 rounded-full"
                style={{ backgroundColor: "#ddd" }}
              ></span>
              <span className="font-medium">
                {t("Stock.StockTable.DefaultProduct.title")}
              </span>
            </div>
          </h5>

          <div className="overflow-x-auto">
            <div className="grid grid-cols-5 bg-purple-50 rounded-t-lg p-3 border border-purple-100 border-b-0 dark:!bg-[#1e1e1e] dark:!border-[#3c3a3d] text-center place-items-center">
              <div className="text-sm font-medium text-[#9e65bb]">
                {t("Stock.StockTable.DefaultProduct.tableHeaders.size")}
              </div>
              <div className="text-sm font-medium text-[#9e65bb]">
                {t("Stock.StockTable.DefaultProduct.tableHeaders.price")}
              </div>
              <div className="text-sm font-medium text-[#9e65bb]">
                {t("Stock.StockTable.DefaultProduct.tableHeaders.quantity")}
              </div>
              <div className="text-sm font-medium text-[#9e65bb]">
                {t("Stock.StockTable.DefaultProduct.tableHeaders.actions")}
              </div>
              <div className="text-sm font-medium text-[#9e65bb]">
                {t("Stock.StockTable.DefaultProduct.tableHeaders.stock")}
              </div>
            </div>

            <div className="border border-purple-100 rounded-b-lg divide-y divide-purple-100 bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d]">
              <div className="grid grid-cols-5 p-3 items-center text-center place-items-center bg-white hover:bg-purple-50 transition-colors dark:!bg-[#181819]">
                <div className="font-medium text-gray-700 dark:text-gray-300">
                  {t("Stock.StockTable.DefaultProduct.row.defaultSize")}
                </div>
                <div className="text-gray-700 dark:text-gray-300">
                  <span className="bg-[#faf1ff] text-[#9e65bb] dark:bg-[#2a2a2a] dark:text-[#b57ed8] px-3 py-1 rounded-lg">
                    {product.price} {localizedCurrency || t("ui.dzd")}
                  </span>
                </div>

                <div className="text-gray-700 dark:text-gray-300">
                  {product.qty || 0}
                </div>
                <div className="text-gray-700 dark:text-gray-300">
                  <button
                    onClick={handleOpenMainProductQtyModal}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleOpenMainProductQtyModal();
                      }
                    }}
                    className="px-3 py-1.5 rounded-md text-xs font-medium bg-blue-50 text-blue-700 dark:bg-[#2a2a2a] dark:text-blue-400 flex items-center gap-1 justify-center transition-colors"
                    tabIndex="0"
                    aria-label={t(
                      "Stock.StockTable.DefaultProduct.ariaLabels.edit"
                    )}
                  >
                    <Edit size={16} />
                    {t("Stock.StockTable.DefaultProduct.row.editButton")}
                  </button>
                </div>

                <div className="text-gray-700 dark:text-gray-300">
                  <button
                    onClick={() => {
                      setStockData({ quantity: "" });
                      setCurrentOptionPath(undefined);
                      setOpenStockModal(true);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setStockData({ quantity: "" });
                        setCurrentOptionPath(undefined);
                        setOpenStockModal(true);
                      }
                    }}
                    className="px-3 py-1.5 rounded-md text-xs font-medium bg-green-50 text-green-700 dark:bg-[#2a2a2a] dark:text-green-400 shadow-sm hover:shadow-md flex items-center gap-1 justify-center transition-colors"
                    tabIndex="0"
                    aria-label={t(
                      "Stock.StockTable.DefaultProduct.ariaLabels.addStock"
                    )}
                  >
                    <Plus size={16} />
                    {t("Stock.StockTable.DefaultProduct.row.addStockButton")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };

    return (
      <div className="p-6 rounded-xl bg-white dark:!bg-[#181819] border border-purple-100 dark:!border-[#3c3a3d] shadow-md m-4">
        {isUpdating && (
          <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center z-10 rounded-xl">
            <div className="bg-white p-4 rounded-lg shadow-lg">
              <p className="text-center">
                {t("Stock.StockTable.StockOptionsDetails.loading")}
              </p>
            </div>
          </div>
        )}

        <h4 className="text-lg dark:!bg-[#181819] font-medium mb-4 text-[#9e65bb] border-b border-purple-100 dark:border-[#3c3a3d] pb-2 sticky top-0 bg-white z-10 flex justify-between items-center">
          <span>{t("Stock.StockTable.StockOptionsDetails.cardTitle")}</span>
          <div className="flex items-center gap-2">
            <button
              onClick={handleOpenAddOptionModal}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleOpenAddOptionModal();
                }
              }}
              className="px-3 py-1.5 rounded-md text-xs font-medium bg-[#9b59bf]  text-white hover:bg-[#814a9f]  transition-colors flex items-center gap-1"
              tabIndex="0"
              aria-label={t(
                "Stock.StockTable.StockOptionsDetails.addOptionButton"
              )}
            >
              <Settings size={16} />
              {t("Stock.StockTable.StockOptionsDetails.addOptionAriaLabel")}
            </button>
          </div>
        </h4>

        <div className="mt-4">
          {/* Always render the default product option first */}
          {renderDefaultProductOption()}

          {/* Then render any additional options */}
          {hasOptions &&
            options.map((option, colorIndex) => {
              // Check if the option should be displayed based on the color flag
              const hasColorFlag = option.color === "1";

              if (hasColorFlag) {
                // Case for color = "1" - display color options normally
                const colorOptionsArray = Array.isArray(option.colorOption)
                  ? option.colorOption
                  : option.colorOption
                  ? [option.colorOption]
                  : [];

                return colorOptionsArray.map(
                  (colorOption, colorOptionIndex) => {
                    if (!colorOption) return null;

                    const colorName =
                      colorOption?.option ||
                      t("Stock.StockTable.StockOptionsDetails.colorTitle");
                    const colorHex = colorOption?.color || "#ddd";

                    return (
                      <div
                        key={`color-${colorIndex}-${colorOptionIndex}`}
                        className="mb-4 bg-purple-50 p-4 rounded-lg border border-purple-100"
                      >
                        <h5 className="text-sm font-medium text-[#9e65bb] mb-3 border-b border-purple-100 pb-2 flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <span
                              className="w-4 h-4 rounded-full"
                              style={{ backgroundColor: colorHex }}
                            ></span>
                            <span>{colorName}</span>
                          </div>
                          <button
                            onClick={() =>
                              handleAddNewSizeOption(
                                colorIndex,
                                colorOptionIndex
                              )
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                handleAddNewSizeOption(
                                  colorIndex,
                                  colorOptionIndex
                                );
                              }
                            }}
                            className="px-3 py-1.5 rounded-md text-xs font-medium bg-[#9b59bf]  text-white hover:bg-[#814a9f]  transition-colors flex items-center gap-1"
                            tabIndex="0"
                            aria-label={t(
                              "Stock.StockTable.StockOptionsDetails.addSizeOrStockAriaLabel"
                            )}
                          >
                            <Plus size={16} />{t(
                              "Stock.StockTable.StockOptionsDetails.addSizeOrStock"
                            )}
                          </button>
                        </h5>

                        {renderSizeOptions(colorOption, [
                          colorIndex,
                          colorOptionIndex,
                        ])}
                      </div>
                    );
                  }
                );
              } else {
                // Case for color = "0" - display options without color information
                const nonColorOptions = Array.isArray(option.colorOption)
                  ? option.colorOption
                  : option.colorOption
                  ? [option.colorOption]
                  : [];

                return nonColorOptions.map((optionItem, optionIndex) => {
                  const optionName =
                    optionItem?.option ||
                    t("Stock.StockTable.StockOptionsDetails.optionDefault");
                  return (
                    <div
                      key={`option-${colorIndex}-${optionIndex}`}
                      className="mb-4 bg-purple-50 p-4 rounded-lg border border-purple-100 dark:!bg-[#181819] dark:!border-[#3c3a3d]"
                    >
                      <h5 className="text-sm font-medium text-[#9e65bb] mb-3 border-b border-purple-100 dark:!border-[#3c3a3d] pb-2 dark:!bg-[#181819] flex items-center justify-between">
                        <span className="">
                          {typeof optionName === "number"
                            ? `${t(
                                "Stock.StockTable.StockOptionsDetails.sizePrefix"
                              )} ${optionName}`
                            : optionName}
                        </span>
                        <button
                          onClick={() =>
                            handleAddNewSizeOption(colorIndex, optionIndex)
                          }
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              handleAddNewSizeOption(colorIndex, optionIndex);
                            }
                          }}
                          className="px-3 py-1.5 rounded-md text-xs font-medium bg-[#9b59bf]  text-white hover:bg-[#814a9f]  transition-colors flex items-center gap-1"
                          tabIndex="0"
                          aria-label={t(
                            "Stock.StockTable.StockOptionsDetails.addSizeOrStockAriaLabel"
                          )}
                        >
                          <Plus size={16} />
                          {t(
                            "Stock.StockTable.StockOptionsDetails.addSizeOrStock"
                          )}
                        </button>
                      </h5>

                      {renderSizeOptions(optionItem, [colorIndex, optionIndex])}
                    </div>
                  );
                });
              }
            })}
        </div>

        <StockModal />
        <AddSizeOptionModal />
        <SelectOptionModal />
        <MainProductQtyModal />
        <AddOptionModal />
      </div>
    );
  };
  const darkModeStyles = `
  /* Mode sombre spécifique au tableau personnalisé */
  .dark table thead tr th {
    background-color: #1e1e1e !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
    border-top: 1px solid #3c3a3d !important;
    border-bottom: 1px solid #3c3a3d !important;
  }

  .dark table tbody tr {
    background-color: #181919 !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
  }

  .dark table tbody tr:nth-child(even) {
    background-color: #1e1e1e !important;
  }

  .dark table tbody tr:nth-child(odd) {
    background-color: #181919 !important;
  }

  .dark table tbody tr td {
    border-color: #3c3a3d !important;
    color: #d1d5db !important;
  }
`;
  return (
    <div className="bg-purple-50 dark:bg-[#141414] rounded-xl shadow-md w-full border border-purple-100 dark:!border-[#3c3a3d]">
      <div className="p-6 flex flex-col h-full">
        <h5 className="font-bold text-lg text-gray-800 m-0 flex items-center dark:text-gray-300">
          {t("Stock.StockTable.cardTitle")}
        </h5>

        <div className="w-full overflow-visible bg-white rounded-xl mt-4 shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full text-end">
              <style>{darkModeStyles}</style>
              <thead>
                <tr className="bg-gradient-to-r from-purple-50 to-purple-100 text-center">
                  {(!displayColumns || displayColumns.image) && (
                    <th className="p-4 font-medium text-[#9e65bb] text-center">
                      {t("Stock.StockTable.tableHeaders.image")}
                    </th>
                  )}
                  {(!displayColumns || displayColumns.name) && (
                    <th
                      colSpan={2}
                      className="p-4 font-medium text-[#9e65bb] text-center"
                    >
                      {t("Stock.StockTable.tableHeaders.name")}
                    </th>
                  )}
                  {(!displayColumns || displayColumns.sku) && (
                    <th className="p-4 font-medium text-[#9e65bb] text-center">
                      {t("Stock.StockTable.tableHeaders.sku")}
                    </th>
                  )}
                  {(!displayColumns || displayColumns.quantity) && (
                    <th className="p-4 font-medium text-[#9e65bb] text-center">
                      {t("Stock.StockTable.tableHeaders.quantity")}
                    </th>
                  )}
                  {(!displayColumns || displayColumns.price) && (
                    <th className="p-4 font-medium text-[#9e65bb] text-center">
                      {t("Stock.StockTable.tableHeaders.price")}
                    </th>
                  )}
                  {(!displayColumns || displayColumns.visits) && (
                    <th className="p-4 font-medium text-[#9e65bb] text-center">
                      {t("Stock.StockTable.tableHeaders.visits")}
                    </th>
                  )}
                  <th className="p-4 font-medium text-[#9e65bb] text-center"></th>
                </tr>
              </thead>

              <tbody>
                {filteredProducts.length > 0 ? (
                  filteredProducts.map((product, index) => (
                    <React.Fragment key={product.id || index}>
                      <tr
                        className={`border-b hover:bg-purple-50 transition-colors ${
                          index % 2 === 0 ? "bg-white" : "bg-gray-50"
                        }`}
                      >
                        {(!displayColumns || displayColumns.image) && (
                          <td className="p-4 justify-center text-center">
                            <div className="relative w-16 h-16 mx-auto">
                              <div className="absolute w-14 h-14 rounded-lg overflow-hidden bg-[#faf1ff] shadow-sm">
                                <img
                                  src={product.image}
                                  alt={
                                    product.name ||
                                    t("Stock.StockTable.imageAlt")
                                  }
                                  className="w-full h-full object-cover"
                                  onError={(e) => {
                                    e.target.src = "/product-foorweb.png";
                                    e.target.className =
                                      "w-full h-full object-contain p-2";
                                  }}
                                />
                              </div>
                            </div>
                          </td>
                        )}

                        {(!displayColumns || displayColumns.name) && (
                          <td
                            colSpan={2}
                            className="p-4 font-medium text-gray-800 text-center"
                          >
                            <div
                              style={{ maxWidth: "250px" }}
                              className="truncate mx-auto"
                            >
                              {product.name}
                            </div>
                          </td>
                        )}

                        {(!displayColumns || displayColumns.sku) && (
                          <td className="p-4 justify-center text-center">
                            <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300 justify-center">
                              <span>{product.sku}</span>
                            </div>
                          </td>
                        )}

                        {(!displayColumns || displayColumns.quantity) && (
                          <td className="p-4 justify-center text-center">
                            <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300 justify-center">
                              <span>{product.qty}</span>
                            </div>
                          </td>
                        )}

                        {(!displayColumns || displayColumns.price) && (
                          <td className="p-4 font-bold justify-center text-center">
                            <div className="flex items-center gap-2 text-[#9e65bb] dark:text-[#d8a6f2] justify-center">
                              <span className="bg-[#faf1ff] dark:bg-[#2b2230] text-[#9e65bb] dark:text-[#d8a6f2] px-3 py-1 rounded-lg">
                                {product.price} {localizedCurrency || t("ui.dzd")}
                              </span>
                            </div>
                          </td>
                        )}

                        {(!displayColumns || displayColumns.visits) && (
                          <td className="p-4 justify-center text-center">
                            <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300 justify-center">
                              <span>{product.visits || 0}</span>
                            </div>
                          </td>
                        )}

                        <td className="p-4 justify-center text-center">
                          <button
                            onClick={() => toggleRow(product.id)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                toggleRow(product.id);
                              }
                            }}
                            className="p-2 rounded-full hover:bg-[#faf1ff] dark:hover:bg-[#2a2a2a] transition-colors"
                            tabIndex="0"
                            aria-label={
                              expandedRows[product.id]
                                ? t("Stock.StockTable.toggleDetails.collapse")
                                : t("Stock.StockTable.toggleDetails.expand")
                            }
                            aria-expanded={
                              expandedRows[product.id] ? "true" : "false"
                            }
                          >
                            {expandedRows[product.id] ? (
                              <ChevronUp
                                size={18}
                                className="text-[#9e68ba] dark:text-[#b57ed8]"
                              />
                            ) : (
                              <ChevronDown
                                size={18}
                                className="text-[#9e68ba] dark:text-[#b57ed8]"
                              />
                            )}
                          </button>
                        </td>
                      </tr>

                      {/* Expanded Row */}
                      {expandedRows[product.id] && (
                        <tr className="bg-purple-50 dark:!bg-[#181819]">
                          <td colSpan={8} className="p-0">
                            <div className="h-fit overflow-y-auto">
                              <ColorOptionsTable
                                product={product}
                                productId={product.id}
                              />
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="p-8 text-center text-gray-500">
                      {t("Stock.StockTable.noResults")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="d-flex justify-content-center py-3 bg-white dark:!bg-[#141414] mt-4 rounded-xl border border-purple-100 dark:!border-[#3c3a3d]">
          {
            <Stack spacing={2} dir="ltr">
              <Pagination
                count={count}
                size="large"
                page={page}
                variant="outlined"
                shape="rounded"
                onChange={handleChange}
                color="secondary"
                sx={{
                  backgroundColor: isDark ? "#181919" : "#ffffff",
                  borderRadius: 2,
                  p: 2,
                  "& .MuiPaginationItem-root": {
                    color: isDark ? "#e1cfff" : "#000000", // Texte
                    borderColor: isDark ? "#a065c0" : "#ccc", // Bordures (si outlined)
                  },
                  "& .MuiPaginationItem-root.Mui-selected": {
                    backgroundColor: isDark ? "#9b59bf" : "#9b59bf", // Background du bouton sélectionné
                    color: "#fff", // Texte sélectionné
                  },
                  "& .MuiPaginationItem-root:hover": {
                    backgroundColor: isDark ? "#7c3aad" : "#f0f0f0", // Hover
                  },
                }}
              />
            </Stack>
          }
        </div>
      </div>
    </div>
  );
};

export default DataTableTemplatingDemoSettings;
